import React from 'react';
import { Link } from 'react-router-dom';
import { DiamondIcon, Instagram, Linkedin, Facebook, ArrowRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-warmwhite relative overflow-hidden" data-id="element-31" data-mp="32num8qaq072f">
      {/* Top Gradient Border */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-plum via-fuchsia to-gold" data-id="element-32" data-mp="36p6aardy4k8i" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8" data-id="element-33" data-mp="3ueim7z0nr6ei">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-34" data-mp="38qvaxf23pqn">
          {/* Col 1: Brand */}
          <div className="flex flex-col gap-6" data-id="element-35" data-mp="3levhb38pzigp">
            <Link to="/" className="flex items-center gap-2 group" data-id="element-36" data-mp="3le2icog05x94">
              <DiamondIcon className="w-6 h-6 text-fuchsia group-hover:text-gold transition-colors" data-id="element-37" data-mp="3qcds6z6as7rc" />
              <span className="font-display font-bold text-2xl text-warmwhite tracking-tight" data-id="element-38" data-mp="29y5g5yj5lgty">
                Silvermark
              </span>
            </Link>
            <p className="text-warmwhite/80 text-sm leading-relaxed" data-id="element-39" data-mp="3l9k7pidf7xfx">
              Clarity for the body to host dreams. A holistic lifestyle
              management company creating clarity so busy women can dream bigger
              and live fuller lives.
            </p>
            {/* Newsletter Mini-signup */}
            <form className="mt-2 flex flex-col gap-3" onSubmit={e => e.preventDefault()} data-id="element-40" data-mp="3q83s3ecd9166">
              <label htmlFor="newsletter-email" className="text-sm font-medium text-warmwhite/90" data-id="element-41" data-mp="81fo5rt1yk23">
                Join our newsletter
              </label>
              <div className="flex" data-id="element-42" data-mp="hsadx65ic1sa">
                <input type="email" id="newsletter-email" placeholder="Your email address" className="bg-warmwhite/10 border border-warmwhite/20 rounded-l-md px-4 py-2 text-sm text-warmwhite placeholder:text-warmwhite/50 focus:outline-none focus:border-fuchsia focus:ring-1 focus:ring-fuchsia w-full" required data-id="element-43" data-mp="ctqm4p48fvs0" />
                <button type="submit" className="bg-gold hover:bg-gold-light text-charcoal px-4 py-2 rounded-r-md transition-colors flex items-center justify-center" aria-label="Subscribe" data-id="element-44" data-mp="ytoak5zkmlyy">
                  <ArrowRight className="w-4 h-4" data-id="element-45" data-mp="18m3o8r3u4oe1" />
                </button>
              </div>
            </form>
          </div>

          {/* Col 2: Quick Links */}
          <div data-id="element-46" data-mp="1hje1gi07qnll">
            <h3 className="font-display font-semibold text-lg mb-6 text-warmwhite" data-id="element-47" data-mp="1hiukp4mau595">
              Quick Links
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-48" data-mp="1riv6cx7n4xgi">
              {['Home', 'Services', 'Shop', 'Courses', 'About'].map(item => <li key={item} data-id="element-49" data-mp="3obx1tcn86wuv">
                  <Link to={item === 'Home' ? '/' : `/${item.toLowerCase()}`} className="text-warmwhite/70 hover:text-fuchsia transition-colors text-sm" data-id="element-50" data-mp="3ocq1jtnrom3i">
                    {item}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Col 3: Connect */}
          <div data-id="element-51" data-mp="21m0jzv7bpevb">
            <h3 className="font-display font-semibold text-lg mb-6 text-warmwhite" data-id="element-52" data-mp="21nlclfa2unqj">
              Connect
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-53" data-mp="1wpjtiucniof2">
              {['Events', 'Community', 'Contact'].map(item => <li key={item} data-id="element-54" data-mp="2tbn50od4j7ke">
                  <Link to={`/${item.toLowerCase()}`} className="text-warmwhite/70 hover:text-fuchsia transition-colors text-sm" data-id="element-55" data-mp="2pc4l9vx1h2j5">
                    {item}
                  </Link>
                </li>)}
              <li data-id="element-56" data-mp="18y4kyjua7avd">
                <Link to="/contact" className="text-gold hover:text-gold-light transition-colors text-sm font-medium" data-id="element-57" data-mp="18ynxfl15x720">
                  Book a Free Call
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Follow Us */}
          <div data-id="element-58" data-mp="2wnhl7uxfpubi">
            <h3 className="font-display font-semibold text-lg mb-6 text-warmwhite" data-id="element-59" data-mp="2wo0u6m53x8de">
              Follow Us
            </h3>
            <div className="flex gap-4" data-id="element-60" data-mp="2isyitjhhqqt7">
              <a href="#" className="w-10 h-10 rounded-full bg-warmwhite/10 flex items-center justify-center text-warmwhite hover:bg-fuchsia hover:text-white transition-all" aria-label="Instagram" data-id="element-61" data-mp="2ntcq2zb9pwq6">
                <Instagram className="w-5 h-5" data-id="element-62" data-mp="3fizbvuow7tgb" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-warmwhite/10 flex items-center justify-center text-warmwhite hover:bg-fuchsia hover:text-white transition-all" aria-label="TikTok" data-id="element-63" data-mp="31l0zguu4u73g">
                {/* Using a generic icon for TikTok as it might not be in lucide-react standard set, or we can use a text fallback or another icon. Let's use a generic video icon or just text if needed. I'll use a play icon as a proxy if TikTok isn't available, but let's try to see if we can just use a simple SVG or text. I'll use a generic hash or music note. */}
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-64" data-mp="1wkjhmnch846a">
                  <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-65" data-mp="zuk0w5m69zcm" />
                </svg>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-warmwhite/10 flex items-center justify-center text-warmwhite hover:bg-fuchsia hover:text-white transition-all" aria-label="LinkedIn" data-id="element-66" data-mp="1dpmi3owgzb4q">
                <Linkedin className="w-5 h-5" data-id="element-67" data-mp="g7majpuikr1l" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-warmwhite/10 flex items-center justify-center text-warmwhite hover:bg-fuchsia hover:text-white transition-all" aria-label="Facebook" data-id="element-68" data-mp="2gb5fhtt09lmy">
                <Facebook className="w-5 h-5" data-id="element-69" data-mp="2q2jhq9ccczjs" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-warmwhite/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-70" data-mp="1xcax8auc2321">
          <p className="text-warmwhite/50 text-sm text-center md:text-left" data-id="element-71" data-mp="22bxeqwh725gn">
            © {new Date().getFullYear()} Silvermark Investments CC. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-72" data-mp="2bclq1jf7drpu">
            <Link to="/privacy" className="text-warmwhite/50 hover:text-warmwhite transition-colors text-sm" data-id="element-73" data-mp="2b9fzs0uu8jsj">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-warmwhite/50 hover:text-warmwhite transition-colors text-sm" data-id="element-74" data-mp="3mssjs1cqwnct">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}